import styled, { css } from "styled-components";

import { OnboardingProps } from "../../redux/slices/onboarding/onboarding";
import { FlexColumn, FlexRow, FlexRowCenter } from "../Common/Styles";

const Container = styled(FlexColumn)<{ $stepName: OnboardingProps.Step }>`
  width: ${({ $stepName }) =>
    $stepName === "people_recommendations" ? 696 : 510}px;
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

const TitleAndDescription = styled(FlexColumn)`
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

const description = css`
  border-radius: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  background: ${({ theme }) => theme.Color.background.neutral.default.value};
  align-items: start;
`;
const Description = styled(FlexRow)`
  ${description};
`;
const DescriptionWithInfo = styled(FlexColumn)`
  ${description};
`;
const InstructionContainer = styled(FlexRowCenter)``;

export const OnboardingStyles = {
  Container,
  TitleAndDescription,
  Description,
  DescriptionWithInfo,
  InstructionContainer,
};
